import { render, staticRenderFns } from "./Gallery12.vue?vue&type=template&id=28501327&scoped=true&"
import script from "./Gallery12.vue?vue&type=script&lang=js&"
export * from "./Gallery12.vue?vue&type=script&lang=js&"
import style0 from "./Gallery12.vue?vue&type=style&index=0&id=28501327&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28501327",
  null
  
)

export default component.exports